import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import { useTranslation } from "@i18n";
import stl from "./OfferCarsV2.module.css";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
var OfferCarsV2 = function OfferCarsV2(_ref) {
  var offers = _ref.offers,
    title = _ref.title,
    _onClick = _ref.onClick;
  var _useTranslation = useTranslation(["web_home"]),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    id: "offer-section",
    className: [stl.offerCarsSection, stl.revampedContainer].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, title && /*#__PURE__*/React.createElement("h2", {
    className: ["big", stl.revampedMobileH, "max-md:px-5"].join(" ")
  }, title), /*#__PURE__*/React.createElement("div", {
    className: [stl.offersBox, stl.revampedMobileBoxShap, stl.normalScrollMob, offers && offers.length <= 3 ? stl.has3Cars : "", "max-md:px-5"].join(" ")
  }, offers.map(function (offer, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      id: "offer-cars_deal-offer-section-".concat(offer.id),
      onClick: function onClick() {
        return _onClick && _onClick(offer.deal_name);
      }
    }, /*#__PURE__*/React.createElement(Link, {
      rel: "noindex, nofollow",
      className: [stl.singleBoxOffer].join(" "),
      to: createUrl("/deal/".concat(offer.id), {}, {
        referral_location: "Home",
        browse_variant: "deals",
        variant_value: offer === null || offer === void 0 ? void 0 : offer.id
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: stl.imageContainer
    }, !isMobile ? /*#__PURE__*/React.createElement("img", {
      width: "274px",
      height: "227px",
      src: offer.box_img_desktop,
      alt: offer === null || offer === void 0 ? void 0 : offer.deal_box_img_title,
      loading: "lazy"
    }) : /*#__PURE__*/React.createElement("img", {
      width: "274px",
      height: "227px",
      src: offer.box_img_mobile,
      alt: offer === null || offer === void 0 ? void 0 : offer.deal_box_img_title,
      loading: "lazy"
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, " ", offer === null || offer === void 0 ? void 0 : offer.deal_box_img_title))));
  }), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/offerspage"),
    className: ["m-show", stl.showMoreMob].join(" ")
  }, /*#__PURE__*/React.createElement("strong", null, t("view_offers", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("i", null))), /*#__PURE__*/React.createElement("a", {
    className: "".concat(stl.viewAlloffers, " whtBtn"),
    href: createUrl("/offerspage"),
    id: "offer-cars_cta"
  }, t("view_offers", {
    ns: "web_home"
  })))));
};
export default OfferCarsV2;